export default __webpack_public_path__ + "b9cf3c36318d03da4e2e5dd4321ccc1e.svg";